/**
 * 週次プロモーション商品計画表画面　週次プロモーション商品計画表出力検索条件VOクラス
 */
export class KYMW4000OutputModel {

  public startOrderCode: string = null;                                         // 受注コード(From)
  public endOrderCode: string = null;                                           // 受注コード(To)
  public promotionNo: string = null;                                            // プロモーションNO

}
